import React, { useState, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/global.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Carga lazy — cada ruta se descarga solo cuando se necesita
const Home = lazy(() => import('./user/home'));
const Register = lazy(() => import('./auth/register'));
const Login = lazy(() => import('./auth/login'));
const InformacionPersonal = lazy(() => import('./components/form-informacion-personal'));
const AdminLogin = lazy(() => import('./admin/auth/login'));
const Dashboard = lazy(() => import('./admin/dashboard'));
const InfoQR = lazy(() => import('./qr-info'));
const MascotasQR = lazy(() => import('./qr-mascotas'));
const HomeMascotas = lazy(() => import('./mascotas/home'));
const RegisterMascotas = lazy(() => import('./auth/register-mascotas'));
const LoginMascotas = lazy(() => import('./auth/login-mascotas'));
const InformacionMascotas = lazy(() => import('./components/form-informacion-mascotas'));
const Desbloquear = lazy(() => import('./desbloquear'));

// Loading minimalista mientras carga el chunk
const LoadingScreen = () => (
    <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-danger" role="status">
            <span className="visually-hidden">Cargando...</span>
        </div>
    </div>
);

const App = () => {
    const [userId] = useState(null);
    return (
        <Router>
            <Suspense fallback={<LoadingScreen />}>
                <Routes>
                    <Route path="/" element={<Home userId={userId} />} />
                    <Route path="/registro/:idUnico" element={<Register />} />
                    <Route path="/iniciar-sesion" element={<Login />} />
                    <Route path="/informacion-personal" element={<InformacionPersonal userId={userId} />} />
                    <Route path="/qr/:idUnico" element={<InfoQR />} />
                    <Route path="/desbloquear/:idUnico" element={<Desbloquear />} />
                    <Route path="/qr-mascotas/:idUnico" element={<MascotasQR />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin/dashboard" element={<Dashboard />} />
                    <Route path="/home-mascotas" element={<HomeMascotas userId={userId} />} />
                    <Route path="/registro-mascotas" element={<RegisterMascotas />} />
                    <Route path="/iniciar-sesion-mascotas" element={<LoginMascotas />} />
                    <Route path="/informacion-mascotas" element={<InformacionMascotas userId={userId} />} />
                </Routes>
            </Suspense>
        </Router>
    );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);